import {
  useQuery,
  useMutation,
  useQueryClient,
  UseQueryResult,
} from '@tanstack/react-query';
import { createLogger } from '@xanectech/lib';
import { type Contacts } from '@xanectech/types';
import { ContactsService } from '../services/ContactService';

const logger = createLogger('Supabase-Client - useContacts');

/**
 * Hook to fetch and manage contacts using the ContactService.
 * Ensures privacy by not exposing sensitive data in logs or errors.
 */
export const useContacts = (): UseQueryResult<Contacts> => {
  return useQuery({
    queryKey: ['contacts'],
    queryFn: () => ContactsService.getAllContacts(),
  });
};

export const useCreateContact = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ContactsService.createContact,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['contacts'] });
    },
    onError: (error) => {
      logger.error('Error creating contact:', error);
    },
  });
};
